module.exports = __webpack_public_path__ + "img/icon-plane.73cf2112.svg";